import './style/App.css';
import './style/index.css';
import { ProjectRoutes } from './routes/ProjectRoutes';

function App() {
  return (
    <>
      <ProjectRoutes />
    </>
  );
}

export default App;
